import PhoneIcon from '/media/illustrations/34.svg'
import { Input } from '../../../common/components/Input'
import { Button } from '../../../common/components/Button'
import { SyntheticEvent, useState } from 'react'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import { AuthLayout } from '@/app/pages/authentication/layout'
import { useAppAlert } from '@/app/AppAlertProvider'
import { AppDispatch, RootState } from '@/storage/store'
import { useDispatch, useSelector } from 'react-redux'
import { ResendTwoFA, VerifyTwoFA, 
  // VerifyTwoFA
 } from '@/apis/users/requests'
import { CircleLoader } from '@/app/common/components/CircleLoader'
import {
  ResetSessionRequest,
  setVerified,
} from '@/app-storage/user/authSessionSlice'
import { useTranslation } from 'react-i18next'
import { ENV } from '@/app/common/constants'


export const TwoFAuth = () => {
  const { t: translate } = useTranslation()
  const { fireAlert } = useAppAlert()
  const navigate = useNavigate()
  const [verificationCode, setVerificationCode] = useState(Array(6).fill(''))
  const [loadingResend, setLoadingResend] = useState(false)
  const [loadingVerify, setLoadingVerify] = useState(false)

  const asyncDispatch = useDispatch<AppDispatch>()
  const AuthState = useSelector((state: RootState) => state.AuthSession)

  const handleCodeChange = (value: string, index: number) => {
    if (value.length > 0 && isNaN(Number(value))) return
    const newCode = [...verificationCode]
    newCode[index] = value
    setVerificationCode(newCode)

    if (value && index < 5) {
      document.getElementById(`code-${index + 1}`)?.focus()
    }
    if (!value && index != 0) {
      document.getElementById(`code-${index - 1}`)?.focus()
    }
  }

  const handleNavigation = async (event: SyntheticEvent) => {
    event.preventDefault()

    const nonEmptyStrings = verificationCode.filter((str) => str.trim() !== '')
    if (nonEmptyStrings.length < 6) {
      fireAlert({
        variant: 'error',
        message: translate('please_add_a_valid_code'),
      }).then()
      return
    }
    setLoadingVerify(true)

    if((ENV.VITE_API_URL).includes("dev-api") || (ENV.VITE_API_URL).includes("dev-ace-api") || (ENV.VITE_API_URL).includes("sandbox-api")){
      // Bypass
      await GetScholarship()
    }else{
      const { error } = await VerifyTwoFA(
        AuthState.phone,
        nonEmptyStrings.join('')
      )
      setLoadingVerify(false)
      if (error) {
        await fireAlert({
          variant: 'error',
          message: error.message,
        })
        setVerificationCode(Array(6).fill(''))
      } else {
        await GetScholarship()
      }
    }
  }

  const GetScholarship = async () => {
    asyncDispatch(setVerified())
    asyncDispatch(ResetSessionRequest())
    navigate(AppRoutePaths.home.index)
    return false
  }

  const handleResend = async () => {
    setLoadingResend(true)
    const { error } = await ResendTwoFA(AuthState.phone)
    setLoadingResend(false)
    if (error) {
      await fireAlert({
        variant: 'error',
        message: error.message,
      })
    } else {
      await fireAlert({
        variant: 'success',
        message: translate('verification_code_sent'),
      })
      setVerificationCode(Array(6).fill(''))
    }
  }

  return (
    <AuthLayout>
      <AuthLayout.Content>
        <form>
          <div className="flex flex-col gap-5 items-center">
            <img alt="Phone" src={PhoneIcon} className="mx-auto h-20 mb-2" />
            <div className="text-center mb-2">
              <h3 className=" text-lg font-semibold text-gray-900 mb-5">
                {translate('verify_your_phone')}
              </h3>
              <div className="flex flex-col">
                <span className="text-sm font-medium text-gray-500 mb-1.5">
                  {translate('enter_the_verification_code_we_sent_to')}
                </span>
                <a className="text-sm font-semibold text-gray-900">
                  ******{AuthState.phone.slice(-4)}{' '}
                </a>
              </div>
            </div>
            <div className="flex space-x-2">
              {verificationCode.map((num, index) => (
                <Input
                  key={index}
                  id={`code-${index}`}
                  type="text"
                  maxLength={1}
                  value={num}
                  autoComplete="off"
                  onChange={(e) => handleCodeChange(e.target.value, index)}
                  className="w-10 h-10 text-center text-2xl border border-gray-300 bg-gray-50 rounded-md"
                />
              ))}
            </div>
            <div className="flex items-center justify-center gap-1 mb-2">
              <span className="text-xs font-medium text-gray-500">
                {translate('didnt_receive_an_email')}
              </span>
              <a
                className="text-xs font-medium link text-primary"
                onClick={handleResend}
              >
                {loadingResend ? (
                  <CircleLoader size="sm" className="mr-1" />
                ) : (
                  translate('resend')
                )}
              </a>
            </div>
            <Button className="w-full" onClick={handleNavigation}>
              <span>
                {loadingVerify
                  ? `${translate('authenticating')}...`
                  : translate('continue')}
              </span>
            </Button>
          </div>
        </form>
      </AuthLayout.Content>
    </AuthLayout>
  )
}
